import React from "react";
import "./ClientsStyles.css";
import Images from "../../assets/images";

const logos = [
  Images.innovation_logo,
  Images.microsoft_logo,
  Images.innovationboost_logo,
  Images.brock_logo,
  Images.legalzone_logo,
  Images.vector_logo,
  Images.unfc_logo,
  Images.herzing_logo,
];

const Clients = () => {
  // Tripling logos for smooth repeat
  const repeatedLogos = [...logos, ...logos, ...logos];

  return (
    <section className="trusted-section">
      <h2 className="trusted-heading">Our Partners and Clients</h2>
      <div className="logo-marquee-container">
        <div className="logo-marquee-track">
          {repeatedLogos.map((logo, index) => (
            <div className="logo-slide" key={index}>
              <img src={logo} alt={`Client logo ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
